import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import DashboardWelcome from './DashboardContent/DashboardWelcome';

export default function DashboardContent() {
    const location = useLocation();

    // Check if we are exactly on the dashboard root
    const isRoot = location.pathname === "/dashboard";

    return (
        <div className="dashboardContent">
             {isRoot ? <DashboardWelcome /> : <Outlet />}
        </div>
    );
}